/*************************************************************************
 *
 *  Copyright 2020 Adobe
 *  All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import React from "react";
import PropTypes from "prop-types";
import hammer from "hammerjs/hammer";
import * as constants from "../../Constants/constants";

class Grabber extends React.Component {
  componentDidMount() {
    const scrollManager = new hammer.Manager(this.elementHandle);

    scrollManager.add(new hammer.Pan({ threshold: 5, pointers: 0 }));
    scrollManager.on("pan", event => {
      this.props.handleGrabberMove(event);
    });

    scrollManager.on("panend", event => {
      this.props.handleTouchEnd(event);
    });

    const doubleTap = new hammer.Tap({
      event: "doubletap",
      taps: 2,
      interval: 500,
      time: 300,
      threshold: 15,
      posThreshold: 20
    });

    scrollManager.add(doubleTap);

    scrollManager.on("doubletap", event => {
      if (event.cancelable !== false) event.preventDefault();
      this.props.setEventOnGrabber(true);
    });

    const singleTap = new hammer.Tap({
      event: "singletap",
      taps: 1
    });
    scrollManager.add(singleTap);

    scrollManager.on("singletap", event => {
      if (event.cancelable !== false) event.preventDefault();
      this.props.setEventOnGrabber(true);
    });

    const longPress = new hammer.Press({
      event: "longpress",
      time: 350
    });
    scrollManager.add(longPress);

    scrollManager.on("longpress", event => {
      if (event.cancelable !== false) event.preventDefault();
      this.props.setEventOnGrabber(true);
    });
  }

  render() {
    const grabberStyle = {
      top: this.props.top,
      left: this.props.left,
      position: "absolute",
      display: this.props.grabberStyle ? "block" : "none",
      height: constants.GRABBER_SIZE,
      width: constants.GRABBER_SIZE
    };

    const outerGrabberStyle = {
      top: this.props.outerTop,
      left: this.props.outerLeft,
      position: "absolute",
      display: this.props.grabberStyle ? "block" : "none",
      height: constants.OUTER_GRABBER_SIZE,
      width: constants.OUTER_GRABBER_SIZE,
      zIndex: 90
    };

    const newStyle = {
      ...grabberStyle,
      ...this.props.classStyle()
    };

    return (
      <div>
        <div style={newStyle} />
        <div
          data-test-id="grabber-mobile"
          onMouseDown={this.props.onMouseDown}
          onMouseMove={this.props.onMouseMove}
          style={outerGrabberStyle}
          ref={handle => {
            this.elementHandle = handle;
          }}
        />
      </div>
    );
  }
}

Grabber.defaultProps = {
  grabberStyle: "none",
  handleGrabberMove: () => null,
  handleTouchEnd: () => null,
  onMouseDown: () => null,
  onMouseMove: () => null,
  classStyle: () => ({})
};

Grabber.propTypes = {
  handleGrabberMove: PropTypes.func,
  handleTouchEnd: PropTypes.func,
  setEventOnGrabber: PropTypes.func.isRequired,
  top: PropTypes.number.isRequired,
  left: PropTypes.number.isRequired,
  outerTop: PropTypes.number.isRequired,
  outerLeft: PropTypes.number.isRequired,
  grabberStyle: PropTypes.string,
  classStyle: PropTypes.func,
  onMouseDown: PropTypes.func,
  onMouseMove: PropTypes.func
};
export default Grabber;
